<template>
    <div class="administer">
        <div class="administerNav">
            <backHeader></backHeader>
        </div>
        <div class="administerCont">
           <div class="html_pst productRelease">
                <div class="release">
                    <el-form :inline="true" class="demo-form-inline lampData">
                       
                        <el-form-item label="色温" class="witd wid150">
                            <el-input v-model="request.exaColorTempe"></el-input>
                        </el-form-item>
                         <el-form-item label="样品编号" class="witd wid150">
                            <el-input v-model="request.posCodeLike"></el-input>
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button type="primary" @click="search(1)">查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="zkbtn">
                    <span class="list_S"  ><el-button slot="reference"  @click="showSetDiv()"><img src="@/assets/images/icon9_27.png" alt="">
                    <span>列表显示项</span>    </el-button></span>
                </div>
                <div class="release2">
                    <el-table :data="tableData" border style="width: 100%" 
                    @selection-change="handleSelectionChange"
                    @row-click="clickRow"
                    fit
                    highlight-current-row
                    :max-height="tableHeight_s2">
                        <!-- <el-table-column  width="55" :key="Math.random()"></el-table-column> -->
                        <el-table-column v-for="(item) in showHideList" v-if="item.isDefault" :key="Math.random()" :prop="item.attrIndex" :label="item.attrName" :fixed="item.isButton?'right':false">
                            <template slot-scope="scope">
                                <span v-if="!item.isButton">{{scope.row[item.attrIndex]}}</span>
                                <el-button
                                v-else
                                size="mini"
                                class="editor"
                                @click="editFn(scope.$index)"
                                >{{scope.row[item.attrIndex]}}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="padding:10px;text-align:center">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="request.page"
                            :page-sizes="[20, 50, 100, 200]"
                            :page-size="20"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                        </el-pagination>
                    </div>
                </div>
           </div>
           <productMsgEditPop v-if="editFlag" @childrenClose="childrenClose" @changeAfter="search" :tableInfo="editData"/>
        </div>
    
    <el-dialog
      :visible.sync="showListShowHideSetDiv"
      v-dialogDrag
      title="列表显示项"
      custom-class="dynamic-class list_SAS list_SASes">
      <div class="contcheck">
        <el-form>
          <el-form-item>
            <div class="cont">
              <div class="conts">
                <div style="cursor:pointer" v-for="(item,index) in showHideList" 
                  :key="index"
                  @click="changeColumn(index,item)" class="li_list">
                  <input type="checkbox" :id="'checkbox_'+index" :checked="item.isDefault ? 'checked' : ''" /><span>{{item.attrName}}</span>
                </div>
              </div>
            </div>
            <div style="clear:both" class="btn">
              <el-button
                style="width:100px;padding:10px"
                type="primary"
                @click="showListShowHideSetDiv = false"
              >确定</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showPic"  v-dialogDrag custom-class="dee imgsAMG">
      <img :src="showPicUrl" />
    </el-dialog>
    </div>
</template>
<script>
import backHeader from '@/views/common/backHeader.vue'
import productMsgEditPop from '@/views/common/productMsgEditPop.vue'
export default {
    data(){
        return{
            //弹窗数据
            editData:{},
            editFlag:false, //编辑按钮弹窗
            showHideList:[
                {
                    isDefault:true,
                    attrIndex:"number",
                    attrName:"编号",
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:"brandId",
                    attrName:"品牌",
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:"lumName",
                    attrName:"样品名称",
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:"posCode",
                    attrName:"样品编号",
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'dictIdLtype',
                    attrName:'灯具类型',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'power',
                    attrName:'功率',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaColorTempe',
                    attrName:'色温',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaLength',
                    attrName:'长度',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaPower',
                    attrName:'电压',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'angle',
                    attrName:'光束角',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaIpLevel',
                    attrName:'IP等级',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaControl',
                    attrName:'控制',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaControlSub',
                    attrName:'分段控制',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaLampColor',
                    attrName:'灯体颜色',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaInstallSupport',
                    attrName:'安装支架',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaInstallSupportType',
                    attrName:'支架支架类型',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaInstallSupportPosition',
                    attrName:'支架位置',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaInstallAngle',
                    attrName:'安装角度调节',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaAttachment',
                    attrName:'可配附件',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaLineDirection',
                    attrName:'出线方向',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'surfaceQuality',
                    attrName:'表面材质',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'lampQuality',
                    attrName:'灯体材质',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'surfaceTemperature',
                    attrName:'表面温度',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'weight',
                    attrName:'重量',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'labelContent',
                    attrName:'标签内容',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'exaAdvantage',
                    attrName:'特点/优势',
                    isButton: false
                },
                {
                    isDefault:true,
                    attrIndex:'operate',
                    attrName:'操作',
                    isButton: true
                },
                
            ],
            showShowHideButton:false,
            showListShowHideSetDiv: false,
            request:{
                exaColorTempe:'',
                posCode:'',
                page:1,
                pageSize:20,
            },
            colorFlagList:[],
            tableData:[],
            totalCount:0,
            currentEditRow:{},
            tableHeight_s2:400,
            multipleSelection:[],
            
      showPic: false, //查看图片
      showPicUrl: "", //图片地址
        }
    },
    created(){
        let self = this
        this.search(1)
    },
    watch:{
        // "request.lumType":function(val){
        //     if(val == ''){
        //         this.showShowHideButton = false
        //     }else{
        //         this.searchShowHideList();
        //         this.showShowHideButton = true
        //     }
        // }
    },
    methods:{
    // 编辑按钮事件
    editFn(e){
        this.editFlag = true;
        this.editData = this.tableData[e];
    },
    //编辑按钮弹窗关闭事件
    childrenClose(){
        this.editFlag = false;
    },
    getSubStr(val){
        var str = val
        if(val.length > 30){
            str = val.substring(0,30)+"..."
        }
        return str
    },
    changeColumn(index,item){
        item.isDefault = !item.isDefault;
    },
    showSetDiv() {
        this.showListShowHideSetDiv = true;
    },
    search(page){
        this.request.page = page
        let self = this
        this.$http.postQueryObj('/api/contestStorageExa/pageJson',{isOrgState:true},this.request,function(res){
            if(res.success){
                // 表格内容
                for(let i=0;i<res.data.rows.length;i++){
                    res.data.rows[i].number = i+1;
                    res.data.rows[i].operate = '编辑'
                }
                self.tableData = res.data.rows
                self.totalCount = res.data.total
            }
        })
    },
    handleSizeChange(pageSize){
        this.request.rows = pageSize
        this.search(1)
    },
    handleCurrentChange(page) {
        this.search(page)
    },
    clickRow(item){
        this.currentEditRow = item
        console.log(item)
    },
    gotoedit(){
        if(this.multipleSelection.length == 0){
            this.$message.error('请选择数据！')
            return false
        }
        if(this.multipleSelection.length >1){
            this.$message.error('只能选择一条')
            return false
        }
        this.$router.push('/productInformation?id='+this.multipleSelection[0].id+"&seriesId="+this.multipleSelection[0].seriesId)
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    productPush(type){
            if(this.multipleSelection.length == 0){
            this.$message.error('请选择数据！')
            return false
        }
        var ids = ''
        for(var i = 0;i<this.multipleSelection.length;i++){
            ids += this.multipleSelection[i].id + ","
        }
        ids = ids.substring(0,ids.length-1)
        //0 未发布 1 已发布
            let self = this
            this.$http.postQuery('/api/stlamps/publish/'+type,{ids:ids},function(res){
                if(res.success){
                    self.$message({
                        message: "操作成功！",
                        type: "success"
                    });
                    self.search(1)
                }else{
                    self.$message.error(res.data)
                }
            })
        
    },
},
    components: {
        backHeader,
        productMsgEditPop
    },
     mounted(){
        this.$nextTick(function () {
            this.tableHeight_s2 = window.innerHeight - 400;
            
            // 监听窗口大小变化
            let self = this;
            window.onresize = function() {
                self.tableHeight_s2 = window.innerHeight - 400
            }
        })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.li_list{
             width: 25%;
            float: left;
            margin-right: 0;
            input{
              position: relative;
              top: 2px;
              margin-right: 3px;
            }
}
.release{
 .witd{
     .el-form-item__content{
         width: 150px;
     }
     
 }
  .el-button--primary {
    background-color: #5b65a1;
    border-radius: 4px;
    border: none;
}
}
.zkbtn{
    text-align: right;
    span.btn{
        display: inline-block;
        padding: 5px 12px;
        border-radius: 4px;
        border: 1px solid #ccc;
        margin-right: 12px;
        cursor: pointer;
        &:hover{
                color: #409EFF;
                border-color: #c6e2ff;
                background-color: #ecf5ff;
        }
    }
    .list_S{
        display: inline-block;
        button{
             padding: 5px 12px 5px;
             height: 36px;
             position: relative;
        }
        span{
            padding-left: 6px;
        }
        img{
            display: inline-block;
            top: 9px;
            height: 16px;
            left: 5px;
            position: absolute;
        }
    }
} 
.release2{
    margin-top: 20px;
    td{
        img{
            width: auto;
            height: auto;
        }
    }
}
</style>